"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array-buffer.detached.js");
require("core-js/modules/es.array-buffer.transfer.js");
require("core-js/modules/es.array-buffer.transfer-to-fixed-length.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.typed-array.at.js");
require("core-js/modules/es.typed-array.find-last.js");
require("core-js/modules/es.typed-array.find-last-index.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.to-reversed.js");
require("core-js/modules/es.typed-array.to-sorted.js");
require("core-js/modules/es.typed-array.with.js");
require("core-js/modules/esnext.uint8-array.set-from-base64.js");
require("core-js/modules/esnext.uint8-array.set-from-hex.js");
require("core-js/modules/esnext.uint8-array.to-base64.js");
require("core-js/modules/esnext.uint8-array.to-hex.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vueAdvancedCropper = require("vue-advanced-cropper");
require("vue-advanced-cropper/dist/style.css");
// Pick 1-4 images, crop each, merge into one square PNG and upload it.
// Emits "uploaded" with the upload API response.
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.isDragging = false;
    this.maxImages = 4;
    this.mergeSize = 1200;
    this.borderWidth = 2;
    this.maxUploadSize = 50 * 1024 * 1024;
    this.images = [];
    this.activeIndex = 0;
    this.mergedPreview = null;
  }
  get activeImage() {
    return this.images[this.activeIndex] || null;
  }
  defaultSize({
    imageSize
  }) {
    return {
      width: imageSize.width,
      height: imageSize.height
    };
  }
  getMimeType(file, fallback = null) {
    const byteArray = new Uint8Array(file).subarray(0, 4);
    let header = '';
    for (let i = 0; i < byteArray.length; i++) {
      header += byteArray[i].toString(16);
    }
    switch (header) {
      case '89504e47':
        return 'image/png';
      case '47494638':
        return 'image/gif';
      case 'ffd8ffe0':
      case 'ffd8ffe1':
      case 'ffd8ffe2':
      case 'ffd8ffe3':
      case 'ffd8ffe8':
        return 'image/jpeg';
      default:
        return fallback;
    }
  }
  applyCrop() {
    const cropper = this.$refs.cropper;
    const img = this.activeImage;
    if (!cropper || !img) return;
    const {
      canvas
    } = cropper.getResult();
    if (!canvas) return;
    img.canvas = canvas;
    img.croppedUrl = canvas.toDataURL('image/png');
    this.updateMergedPreview();
  }
  // Cell rectangles [x, y, w, h] for the given image count, auto layout
  getLayout(count) {
    const S = this.mergeSize;
    const h = S / 2;
    switch (count) {
      case 1:
        return [[0, 0, S, S]];
      case 2:
        return [[0, 0, h, S], [h, 0, h, S]];
      case 3:
        return [[0, 0, h, S], [h, 0, h, h], [h, h, h, h]];
      default:
        return [[0, 0, h, h], [h, 0, h, h], [0, h, h, h], [h, h, h, h]];
    }
  }
  loadHtmlImage(src) {
    return new Promise((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = reject;
      el.src = src;
    });
  }
  async buildMergedCanvas() {
    const S = this.mergeSize;
    const canvas = document.createElement('canvas');
    canvas.width = S;
    canvas.height = S;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, S, S);
    ctx.imageSmoothingQuality = 'high';
    const cells = this.getLayout(this.images.length);
    for (let i = 0; i < cells.length; i++) {
      const item = this.images[i];
      const source = item.canvas || (await this.loadHtmlImage(item.src));
      const [x, y, w, h] = cells[i];
      const sw = source.width;
      const sh = source.height;
      if (w === h) {
        // Square cell: "cover" fit, fill the cell and crop overflow from the center
        const scale = Math.max(w / sw, h / sh);
        const cw = w / scale;
        const ch = h / scale;
        ctx.drawImage(source, (sw - cw) / 2, (sh - ch) / 2, cw, ch, x, y, w, h);
      } else {
        // Tall cell: "contain" fit, show the whole image centered on white
        const scale = Math.min(w / sw, h / sh);
        const dw = sw * scale;
        const dh = sh * scale;
        ctx.drawImage(source, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
      }
    }
    // Border lines between images (no outer padding)
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = this.borderWidth;
    cells.forEach(([x, y, w, h]) => {
      if (x + w < S) {
        ctx.beginPath();
        ctx.moveTo(x + w, y);
        ctx.lineTo(x + w, y + h);
        ctx.stroke();
      }
      if (y + h < S) {
        ctx.beginPath();
        ctx.moveTo(x, y + h);
        ctx.lineTo(x + w, y + h);
        ctx.stroke();
      }
    });
    return canvas;
  }
  async updateMergedPreview() {
    if (!this.images.length) {
      this.mergedPreview = null;
      return;
    }
    const canvas = await this.buildMergedCanvas();
    this.mergedPreview = canvas.toDataURL('image/png');
  }
  async uploadMerged() {
    if (!this.images.length) return;
    const canvas = await this.buildMergedCanvas();
    // Lossless PNG, no compression
    canvas.toBlob(async blob => {
      if (!blob) return;
      if (blob.size > this.maxUploadSize) {
        this.$message.error('The merged image is larger than 50MB.');
        return;
      }
      const form = new FormData();
      form.append('file', blob, 'image.png');
      try {
        this.loading = true;
        const response = await this.uploadFn(form);
        this.$emit('uploaded', response);
        this.reset();
      } catch (error) {
        console.error('Failed to upload image', error);
      } finally {
        this.loading = false;
      }
    }, 'image/png');
  }
  moveImage(index, dir) {
    const target = index + dir;
    if (target < 0 || target >= this.images.length) return;
    const item = this.images.splice(index, 1)[0];
    this.images.splice(target, 0, item);
    this.activeIndex = target;
    this.updateMergedPreview();
  }
  removeImage(index) {
    URL.revokeObjectURL(this.images[index].src);
    this.images.splice(index, 1);
    if (this.activeIndex >= this.images.length) {
      this.activeIndex = Math.max(0, this.images.length - 1);
    }
    this.updateMergedPreview();
  }
  reset() {
    this.images.forEach(img => URL.revokeObjectURL(img.src));
    this.images = [];
    this.activeIndex = 0;
    this.mergedPreview = null;
  }
  readMimeType(file) {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = e => resolve(this.getMimeType(e.target.result, file.type));
      reader.readAsArrayBuffer(file);
    });
  }
  async loadImageFromDisc(event) {
    const files = Array.from(event.target.files || []);
    if (event.target.value !== undefined) event.target.value = '';
    if (!files.length) return;
    const acceptable = ['.jpeg', '.jpg', '.png'];
    const remaining = this.maxImages - this.images.length;
    if (files.length > remaining) {
      this.$message.error(`You can add up to ${this.maxImages} images (${remaining} more allowed).`);
      return;
    }
    for (const file of files) {
      const ext = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();
      if (acceptable.indexOf(ext) === -1) {
        this.$message.error('file type not permitted!');
        return;
      }
    }
    for (const file of files) {
      const type = await this.readMimeType(file);
      this.images.push({
        src: URL.createObjectURL(file),
        type,
        canvas: null,
        croppedUrl: null
      });
    }
    this.activeIndex = this.images.length - 1;
    this.updateMergedPreview();
  }
  onDrop(event) {
    var _event$dataTransfer;
    this.isDragging = false;
    const files = (_event$dataTransfer = event.dataTransfer) === null || _event$dataTransfer === void 0 ? void 0 : _event$dataTransfer.files;
    if (files && files.length) {
      this.loadImageFromDisc({
        target: {
          files
        }
      });
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], default_1.prototype, "uploadFn", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ImageMerger',
  components: {
    Cropper: _vueAdvancedCropper.Cropper
  }
})], default_1);
var _default = exports.default = default_1;